import React from 'react';
import Box from '@mui/material/Box';

const Loading = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="transparent"
    >
      <img
        src="/assets/loading.svg"
        alt="Loading SVG"
        style={{ width: 72, height: 72 }}
      />
    </Box>
  );
};

export default Loading;
